// Cart Drawer Functionality
(function() {
  'use strict';

  // Initialize cart on page load
  document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
    initializeCartEvents();
  });

  // Fetch cart data from Shopify
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      updateCartUI(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  // Update all cart UI elements
  function updateCartUI(cart) {
    // Update header cart count
    const cartCounts = document.querySelectorAll('.cart-count');
    cartCounts.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Update drawer cart count
    const cartDrawerCount = document.querySelector('.cart-drawer-count');
    if (cartDrawerCount) {
      cartDrawerCount.textContent = cart.item_count;
    }

    // Render cart items
    renderCartItems(cart);
  }

  // Render cart items in drawer
  function renderCartItems(cart) {
    const cartItemsContainer = document.querySelector('.cart-items');
    const emptyCart = document.querySelector('.empty-cart');
    const cartFooter = document.querySelector('.cart-footer');
    const cartItemsWrapper = document.querySelector('.cart-items-container');
    const subtotalAmount = document.querySelector('.cart-subtotal-amount');

    if (!cartItemsContainer) return;

    if (cart.items.length === 0) {
      if (emptyCart) emptyCart.style.display = 'flex';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartItemsWrapper) cartItemsWrapper.style.display = 'none';
      return;
    }

    // Show cart items, hide empty state
    if (emptyCart) emptyCart.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartItemsWrapper) cartItemsWrapper.style.display = 'block';

    let html = '';
    cart.items.forEach(item => {
      const itemImage = item.image || item.featured_image?.url || '';
      const itemTitle = item.product_title || item.title;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      
      html += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-image">
            ${itemImage ? `<img src="${itemImage}" alt="${itemTitle}">` : ''}
          </div>
          <div class="cart-item-details">
            <div class="cart-item-title">${itemTitle}</div>
            ${variantTitle ? `<div class="cart-item-variant">${variantTitle}</div>` : ''}
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item-quantity">
              <div class="quantity-controls">
                <button class="quantity-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease quantity">−</button>
                <span class="quantity-value">${item.quantity}</span>
                <button class="quantity-btn" data-action="increase" data-key="${item.key}" aria-label="Increase quantity">+</button>
              </div>
              <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    cartItemsContainer.innerHTML = html;

    // Update subtotal
    if (subtotalAmount) {
      subtotalAmount.textContent = formatMoney(cart.total_price);
    }

    // Re-attach event listeners
    attachCartItemEvents();
  }

  // Attach event listeners to cart items
  function attachCartItemEvents() {
    document.querySelectorAll('.quantity-btn').forEach(btn => {
      btn.addEventListener('click', handleQuantityChange);
    });

    document.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', handleRemoveItem);
    });
  }

  // Handle quantity change
  async function handleQuantityChange(e) {
    const action = e.target.dataset.action;
    const key = e.target.dataset.key;
    const quantitySpan = e.target.parentElement.querySelector('.quantity-value');
    let quantity = parseInt(quantitySpan.textContent);

    if (action === 'increase') {
      quantity++;
    } else if (action === 'decrease' && quantity > 1) {
      quantity--;
    }

    await updateCartItem(key, quantity);
  }

  // Handle item removal
  async function handleRemoveItem(e) {
    const key = e.target.dataset.key;
    await updateCartItem(key, 0);
  }

  // Update cart item quantity
  async function updateCartItem(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (!response.ok) throw new Error('Failed to update cart');

      const cart = await response.json();
      updateCartUI(cart);
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // Format money (Shopify format)
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  // Initialize cart-related events
  function initializeCartEvents() {
    // Add to cart forms
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      if (form.dataset.ajaxCartBound === 'true') return;
      form.addEventListener('submit', handleAddToCart);
      form.dataset.ajaxCartBound = 'true';
    });
  }

  // Handle add to cart
  async function handleAddToCart(e) {
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;

    const originalHTML = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.innerHTML = '<span class="spinner"></span> Adding...';

    const notifier = window.AnneRolloTheme && typeof window.AnneRolloTheme.showNotification === 'function'
      ? window.AnneRolloTheme.showNotification
      : null;

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      await fetchCart();
      if (typeof window.toggleCart === 'function') {
        window.toggleCart(true);
      }
      if (notifier) {
        notifier('Product added to cart!', 'success');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      if (notifier) {
        notifier('Error adding to cart', 'error');
      } else {
        alert('Error adding to cart. Please try again.');
      }
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalHTML;
      submitBtn.removeAttribute('aria-busy');
    }
  }

  // Make fetchCart available globally for other scripts
  window.refreshCart = fetchCart;

})();
